module.exports = __webpack_public_path__ + "static/media/wavm8s-011-roxas.a210f9f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-011-roxas.mp3
// module id = 9lEq
// module chunks = 0